import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { AlertTriangle, Calendar, CheckCircle, Clock } from "lucide-react";
import React from "react";
import { useServiceRequestSummary } from "../../hooks";

export const Summary: React.FC = () => {
  const remoteUtilityId = getRemoteUtilityId();

  const {
    data: summaryData,
    isLoading,
    error,
  } = useServiceRequestSummary({
    remoteUtilityId,
    requestType: "Service",
  });

  // Show loading state
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white rounded-lg shadow p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          </div>
        ))}
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-600">
          Failed to load service request summary data.
        </p>
      </div>
    );
  }

  const summary = summaryData?.result;
  console.log("summary", summary);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <QuickStatsCard
        title="Pending Service Requests"
        tooltip="Number of service requests awaiting action."
        count={summary?.totalPending || 0}
        trend={summary?.percentChange?.pending || 0}
        trendDirection={summary?.percentChange?.pending >= 0 ? "up" : "down"}
        icon={<AlertTriangle className="h-8 w-8 text-amber-500" />}
      />
      <QuickStatsCard
        title="Completed Today"
        tooltip="Service requests successfully completed today."
        count={summary?.totalCompletedToday || 0}
        trend={summary?.percentChange?.completedToday || 0}
        trendDirection={
          summary?.percentChange?.completedToday >= 0 ? "up" : "down"
        }
        icon={<Calendar className="h-8 w-8 text-blue-500" />}
      />
      <QuickStatsCard
        title="Rejected Today"
        tooltip="Service requests that were declined or canceled."
        count={summary?.totalRejectedToday || 0}
        trend={summary?.percentChange?.rejectedToday || 0}
        trendDirection={
          summary?.percentChange?.rejectedToday >= 0 ? "up" : "down"
        }
        icon={<Clock className="h-8 w-8 text-purple-500" />}
      />
      <QuickStatsCard
        title="Total Completed"
        tooltip="Cumulative count of all completed service requests."
        count={summary?.totalCompleted || 0}
        trend={summary?.percentChange?.totalCompleted || 0}
        trendDirection={
          summary?.percentChange?.totalCompleted >= 0 ? "up" : "down"
        }
        icon={<CheckCircle className="h-8 w-8 text-green-500" />}
      />
    </div>
  );
};
